import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignItemsMiddle = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M6.5 12H3V4h3.5v8Zm-5-3.5H2V12a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V8.5h1V10a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1V8.5h.5a.5.5 0 0 0 0-1H14V6a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v1.5h-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.5h-.5a.5.5 0 0 0 0 1ZM13 8v2H9.5V6H13v2Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default AlignItemsMiddle
